// Google Identity Services (Masuk dengan Google), shared by the login page and
// the "Akun Google" card on Profile. The backend verifies the ID token; this
// file only loads Google's script and draws its button.
import { API_BASE_URL } from "./config";

const GSI_SRC = "https://accounts.google.com/gsi/client";

let scriptPromise = null;

export function loadGoogleScript() {
  if (window.google?.accounts?.id) return Promise.resolve(window.google);
  if (!scriptPromise) {
    scriptPromise = new Promise((resolve, reject) => {
      const script = document.createElement("script");
      script.src = GSI_SRC;
      script.async = true;
      script.defer = true;
      script.onload = () => resolve(window.google);
      script.onerror = () => {
        scriptPromise = null; // let a later attempt retry
        script.remove();
        reject(new Error("Gagal memuat Google Sign-In."));
      };
      document.head.appendChild(script);
    });
  }
  return scriptPromise;
}

// The client ID is public and comes from the backend at runtime, so no
// REACT_APP_ variable (and no rebuild) is needed to turn the feature on.
export async function fetchGoogleConfig() {
  try {
    const res = await fetch(`${API_BASE_URL}/api/auth/google/config/`);
    if (!res.ok) return { enabled: false, client_id: "" };
    const data = await res.json();
    return { enabled: !!data.enabled, client_id: data.client_id || "" };
  } catch {
    return { enabled: false, client_id: "" };
  }
}

// Draws Google's own button into `element` and calls onCredential(idToken)
// when the person finishes picking an account. `text` is one of GIS's button
// texts: "signin_with" | "signup_with" | "continue_with". `shape` is GIS's
// "pill" | "rectangular". The button is always the white "outline" theme: it
// reads fine on both the light and dark pages.
export async function renderGoogleButton({
  clientId,
  element,
  onCredential,
  text = "signin_with",
  shape = "pill",
}) {
  const google = await loadGoogleScript();
  if (!element.isConnected) return; // page changed while the script was loading

  google.accounts.id.initialize({
    client_id: clientId,
    callback: (response) => {
      if (response?.credential) onCredential(response.credential);
    },
    ux_mode: "popup",
    auto_select: false,
  });

  element.innerHTML = "";
  google.accounts.id.renderButton(element, {
    type: "standard",
    theme: "outline",
    size: "large",
    shape,
    text,
    logo_alignment: "left",
    locale: "id",
    width: Math.min(400, Math.max(200, element.clientWidth || 320)),
  });
}
